import React, {PureComponent} from 'react';
import {IInventoryState} from "../components/Inventory/models";
import {InventoryService} from "../components/Inventory/Inventory.service";
import Spinner from "react-bootstrap/Spinner";
import {InventoryTable} from "../components/Inventory/InventoryTable";
import {InventorySearchBar} from "../components/Inventory/InventorySearchBar";
import {AuthenticationContext} from "../services/context/authentication.context";
import { PageProps } from 'models/page';
import { LOCAL_STORAGE_KEYS } from 'common/constants/localStorageKeys';

export class Inventory extends PureComponent<PageProps, IInventoryState> {

    static contextType = AuthenticationContext;
    constructor(props: PageProps) {
        super(props);
        this.state = {
            customerId: Number(localStorage.getItem(LOCAL_STORAGE_KEYS.CUSTOMER_ID)),
            loading: true,
            inventoryData: []
        };
        this.props.onLoadValidatePage();
    }

    getInventory = () => {
        InventoryService.getInventoryData(this.state.customerId).then(data => {
            this.setState({
                inventoryData: data,
                loading: false
            })
        }).catch((reason: any) => {
            console.error(reason);
            this.setState({loading: false});
        })
    };

    updateCustomerId = () => {
        if (this.context.state.customerId !== this.state.customerId) {
            this.setState({
                ...this.state,
                loading: true,
                customerId: this.context.state.customerId,
            }, () => {
                this.getInventory();
            });
        }
    };

    componentDidMount(): void {
        this.getInventory();
    }

    componentDidUpdate(prevProps: Readonly<any>, prevState: Readonly<IInventoryState>, snapshot?: any): void {
        this.updateCustomerId();
    }

    render() {
        return (
            <div className="document-rows__container">

                <InventorySearchBar/>
                {/*<div className="row">*/}
                {/*    <div className="col">*/}
                {
                    this.state.loading &&
                    <div className="text-center"><Spinner animation={"grow"}/></div>
                }
                {
                    !this.state.loading &&
                    <InventoryTable inventoryData={this.state.inventoryData}/>
                }
                {/*</div>*/}
                {/*</div>*/}
            </div>
        );
    }
}
